export default __webpack_public_path__ + "static/media/search.b6f3e37d.jpg";